import { defineNuxtPlugin } from '#app/nuxt';
import { createApiFetch, isEnginePanicError, onApiResponseError } from '#layers/base/public';
import { useErrorStore } from '#layers/ui/public';

export default defineNuxtPlugin((_nuxtApp) => {
	// Registered here, not in the factory: `layers/base` must not depend on `layers/ui`.
	onApiResponseError(({ data }) => {
		if (isEnginePanicError(data)) {
			useErrorStore().setGlobalError(data);
		}
	});

	globalThis.$fetch = createApiFetch() as typeof globalThis.$fetch;
});
